import { Badge } from '@frontend-platform/ui-lib/ui';

// Ported from aistudio's ActionTag.vue. The visible text is the raw backend
// action string (capitalized via CSS) — only the color/border variant is
// looked up by action type.
const UPDATE_ACTIONS = new Set(['replace', 'insert_after', 'insert_before', 'enable', 'create']);
const REMOVE_ACTIONS = new Set(['delete']);

export function ActionTag({ action }: { action?: string }) {
  if (!action) return null;

  const classes = UPDATE_ACTIONS.has(action)
    ? 'border-[#b3f3f5] bg-cyan-50 text-[#007882]'
    : REMOVE_ACTIONS.has(action)
      ? 'border-[#e3defc] bg-[#f8f7ff] text-[#4d39e9]'
      : 'border-border bg-muted text-muted-foreground';

  return (
    <Badge variant="outline" className={`rounded-full capitalize leading-[18px] ${classes}`}>
      {action}
    </Badge>
  );
}
